import jwtDecode from "jwt-decode";
import { z } from "zod";

import { UserRole } from "@/enums/user.enum";

export const TOKEN_KEY = "zvcbcve";

const claimsSchema = z.object({
  roles: z.array(z.number()),
});

export function getTokenClaims() {
  const token = localStorage.getItem(TOKEN_KEY);
  const decodedToken = jwtDecode(token || "");

  return claimsSchema.parse(decodedToken);
}

export function isMaster() {
  try {
    const claims = getTokenClaims();

    return claims.roles.includes(UserRole.MASTER);
  } catch {
    return false;
  }
}

export function isCompanyMaster() {
  try {
    const claims = getTokenClaims();

    return claims.roles.includes(UserRole.COMPANY_MASTER);
  } catch {
    return false;
  }
}

export function isCompanyEmployee() {
  try {
    const claims = getTokenClaims();

    return claims.roles.includes(UserRole.COMPANY_WORKER);
  } catch {
    return false;
  }
}
